import { type AuthToken } from '@reliance/types/models/Auth';
import { type ApiSuccessResponse, type ApiService } from '../types/ApiService';
import {
  type InmateRequest,
  type InmateRequestMessage,
} from '@reliance/types/models/InmateRequest';

export const inmateRequest = (
  centralApi: ApiService,
  getToken: () => AuthToken,
) => ({
  get: (id: number): Promise<InmateRequest> => {
    return centralApi.get(`/inmate-request/${id}`);
  },
  put: (inmateRequestId: number, data): Promise<ApiSuccessResponse<void>> => {
    return centralApi.put(`/inmate-request/${inmateRequestId}`, data);
  },
  post: (data: FormData): Promise<ApiSuccessResponse<InmateRequest>> => {
    return centralApi.post('/inmate-request', data, {
      contentType: false,
    });
  },
  postMultiple: (
    data: FormData,
  ): Promise<ApiSuccessResponse<InmateRequest>> => {
    return centralApi.post('/inmate-request/multiple', data, {
      contentType: false,
    });
  },
  postResponse: (
    inmateRequestId: number,
    data: FormData,
  ): Promise<ApiSuccessResponse<InmateRequestMessage>> => {
    return centralApi.post(
      `/inmate-request/${inmateRequestId}/response`,
      data,
      {
        contentType: false,
      },
    );
  },
  deleteAttachment: (mailId: number): Promise<ApiSuccessResponse<void>> => {
    return centralApi.delete(`/inmate-request/${mailId}/asset`);
  },
  pdfUrl: (ids: string): string => {
    return centralApi.buildUrl('/inmate-request.pdf', {
      ids,
      includeEmails: true,
      token: getToken().accessToken,
    });
  },
});
